import { Component, Element, h, Host, Prop } from '@stencil/core';
import { Size, SIZES } from '../../../models/sizes.types';

@Component({
  tag: 'wink-spacer',
  styleUrl: 'styles/spacer.default.scss',
  shadow: true,
})
export class Spacer {
  @Element() host!: HTMLWinkSpacerElement;

  @Prop() size: Size = SIZES.md;

  render() {
    return (
      <Host>
        <div class={`height-${this.size}`} />
      </Host>
    );
  }
}
